import { createContext } from 'react'

export const SpendContext = createContext()

export const SidebarContext = createContext()

export const SheetContext = createContext()

export const BudgetContext = createContext()

export const SelectSearchContext = createContext()
